// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wrapper {
  padding: 45px 0 0;
  position: relative;
  text-align: center;
  background: var(--color-background-alt);
}
.wrapper .close-icon {
  position: absolute;
  top: 15px;
  right: 15px;
  margin: 0px;
  background: var(--color-white-accent);
  width: 35px;
  height: 35px;
  padding: 0px;
  z-index: 99;
}
.wrapper .close-icon ion-icon {
  width: 100%;
  height: 100%;
  margin: 0px;
}
.wrapper .close-icon:hover {
  background: #f2dbd9;
}
.wrapper h3 {
  padding: 0 10px;
}
.wrapper .items {
  width: 100%;
  overflow-y: auto;
  max-height: 50vh;
  margin-bottom: 10px;
}

ion-button {
  position: relative;
}
ion-button .buuton-text {
  color: var(--color-black);
  font-family: AppFontMedium, sans-serif;
  margin-right: 0;
  font-size: 14px;
  text-wrap: auto;
}
@media (max-width: 992px) {
  ion-button .buuton-text {
    font-size: 10px;
  }
}
ion-button .button-icon {
  position: absolute;
  right: 5px;
  height: 34px;
  width: 34px;
}

.center-element {
  display: flex;
  align-items: center;
  justify-content: center;
}

.title {
  font-size: 24px;
  line-height: 116%;
  letter-spacing: 0.02em;
  font-family: AppFontMedium;
  text-align: center;
  text-transform: uppercase;
}

.title.sub {
  font-size: 18px;
}

.button-footer-block {
  margin: 0px !important;
  padding: 28px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 16px;
  border-top: 1px solid var(--color-black);
}
.button-footer-block .left-button {
  width: 65%;
  height: auto;
  min-height: 30px;
  background: #F6F1EF;
  border-radius: 26px;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.button-footer-block .left-button.disabled {
  opacity: 0.5;
}
.button-footer-block .left-button h2, .button-footer-block .left-button p {
  font-size: 14px;
  margin: 0 auto;
  font-family: AppFontMedium;
  color: var(--color-black);
  text-transform: uppercase;
}
@media (max-width: 992px) {
  .button-footer-block .left-button h2, .button-footer-block .left-button p {
    font-size: 12px;
  }
}
.button-footer-block .left-button:hover {
  background: #f2dbd9;
}
.button-footer-block .left-button .left-price {
  background: #F6F1EF;
  min-height: 30px;
  height: 100%;
  border-radius: 26px;
  border: 1px solid var(--primary-btn);
  padding: 0px 10px;
}
.button-footer-block .button-checkout {
  width: 34%;
  height: auto;
  min-height: 30px;
  display: flex;
  align-items: center;
  background: #F6F1EF;
  border-radius: 26px;
}
.button-footer-block .button-checkout:hover {
  background: #f2dbd9;
}
.button-footer-block .button-checkout.disabled {
  opacity: 0.5;
}
@media (max-width: 992px) {
  .button-footer-block .button-checkout {
    height: 40px;
  }
  .button-footer-block .button-checkout p {
    font-size: 12px;
  }
}
.button-footer-block .button-checkout.disabled {
  opacity: 0.5;
}
.button-footer-block .button-checkout p {
  font-size: 14px;
}
.button-footer-block .button-checkout .right-checkout {
  cursor: pointer;
  margin: 0 auto;
  padding: 0px 15px 0px 10px;
  text-transform: uppercase;
}
.button-footer-block .button-checkout .right-checkout p {
  color: var(--color-black);
  font-family: AppFontMedium;
}`, "",{"version":3,"sources":["webpack://./src/app/components/choose-size-of-product/choose-size-of-product.component.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AAEA;EACC,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,uCAAA;AADD;AAEC;EAEC,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,qCAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;AADF;AAEE;EACC,WAAA;EACA,YAAA;EACA,WAAA;AAAH;AAEE;EACC,mBAAA;AAAH;AAGC;EACC,eAAA;AADF;AAGC;EACC,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;AADF;;AAIA;EACC,kBAAA;AADD;AAGC;EACC,yBAAA;EACA,sCAAA;EACA,eAAA;EACA,eAAA;EACA,eAAA;AADF;ACrCE;EDiCD;IAOE,eAAA;EACD;AACF;AACC;EACC,kBAAA;EACA,UAAA;EACA,YAAA;EACA,WAAA;AACF;;AAEA;EACC,aAAA;EACA,mBAAA;EACA,uBAAA;AACD;;AACA;EACC,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,0BAAA;EACA,kBAAA;EACA,yBAAA;AAED;;AAAA;EACC,eAAA;AAGD;;AAAA;EACC,sBAAA;EACA,aAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,eAAA;EACA,wCAAA;AAGD;AAFC;EACC,UAAA;EACA,YAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;EACA,eAAA;EAIA,aAAA;EACA,8BAAA;EACA,mBAAA;AACF;AANE;EACC,YAAA;AAQH;AAHE;EACC,eAAA;EACA,cAAA;EACA,0BAAA;EACA,yBAAA;EACA,yBAAA;AAKH;ACnGE;EDyFA;IAOE,eAAA;EAOF;AACF;AALE;EACC,mBAAA;AAOH;AALE;EACC,mBAAA;EACA,gBAAA;EACA,YAAA;EACC,mBAAA;EACA,oCAAA;EACA,iBAAA;AAOJ;AAHC;EACC,UAAA;EACA,YAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EAEA,mBAAA;EACA,mBAAA;AAIF;AAHE;EACC,mBAAA;AAKH;AAHE;EACC,YAAA;AAKH;AClIE;EDgHD;IAgBE,YAAA;EAMD;EAJC;IACC,eAAA;EAMF;AACF;AAJE;EACC,YAAA;AAMH;AAJE;EACC,eAAA;AAMH;AAHE;EACC,eAAA;EACA,cAAA;EACA,0BAAA;EAKA,yBAAA;AACH;AALG;EACC,yBAAA;EACA,0BAAA;AAOJ","sourcesContent":["@import '../../../theme/mixins';\n\n.wrapper {\n\tpadding: 45px 0 0;\n\tposition: relative;\n\ttext-align: center;\n\tbackground: var(--color-background-alt);\n\t.close-icon {\n\n\t\tposition: absolute;\n\t\ttop: 15px;\n\t\tright: 15px;\n\t\tmargin: 0px;\n\t\tbackground: var(--color-white-accent);\n\t\twidth: 35px;\n\t\theight: 35px;\n\t\tpadding: 0px;\n\t\tz-index: 99;\n\t\tion-icon {\n\t\t\twidth: 100%;\n\t\t\theight: 100%;\n\t\t\tmargin: 0px;\n\t\t}\n\t\t&:hover {\n\t\t\tbackground: #f2dbd9;\n\t\t}\n}\n\th3 {\n\t\tpadding: 0 10px;\n\t}\n\t.items {\n\t\twidth: 100%;\n\t\toverflow-y: auto;\n\t\tmax-height: 50vh;\n\t\tmargin-bottom: 10px;\n\t}\n}\nion-button {\n\tposition: relative;\n\n\t.buuton-text {\n\t\tcolor: var(--color-black);\n\t\tfont-family: AppFontMedium, sans-serif;\n\t\tmargin-right: 0;\n\t\tfont-size: 14px;\n\t\ttext-wrap: auto;\n\t\t@include mobile {\n\t\t\tfont-size: 10px;\n\t\t}\n\t}\n\t.button-icon {\n\t\tposition: absolute;\n\t\tright: 5px;\n\t\theight: 34px;\n\t\twidth: 34px;\n\t}\n}\n.center-element {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n}\n.title {\n\tfont-size: 24px;\n\tline-height: 116%;\n\tletter-spacing: 0.02em;\n\tfont-family: AppFontMedium;\n\ttext-align: center;\n\ttext-transform: uppercase;\n}\n.title.sub {\n\tfont-size: 18px;\n}\n\n.button-footer-block {\n\tmargin: 0px !important;\n\tpadding: 28px;\n\twidth: 100%;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-between;\n\tfont-size: 16px;\n\tborder-top: 1px solid var(--color-black);\n\t.left-button {\n\t\twidth: 65%;\n\t\theight: auto;\n\t\tmin-height: 30px;\n\t\tbackground: #F6F1EF;\n\t\tborder-radius: 26px;\n\t\tcursor: pointer;\n\t\t&.disabled {\n\t\t\topacity: 0.5;\n\t\t}\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\talign-items: center;\n\t\th2,p {\n\t\t\tfont-size: 14px;\n\t\t\tmargin: 0 auto;\n\t\t\tfont-family: AppFontMedium;\n\t\t\tcolor: var(--color-black);\n\t\t\ttext-transform: uppercase;\n\t\t\t@include mobile {\n\t\t\t\tfont-size: 12px;\n\t\t\t}\n\t\t}\n\t\t&:hover {\n\t\t\tbackground: #f2dbd9;\n\t\t}\n\t\t.left-price {\n\t\t\tbackground: #F6F1EF;\n\t\t\tmin-height: 30px;\n\t\t\theight: 100%;\n    border-radius: 26px;\n    border: 1px solid var(--primary-btn);\n    padding: 0px 10px;\n\t\t}\n\t}\n\n\t.button-checkout {\n\t\twidth: 34%;\n\t\theight: auto;\n\t\tmin-height: 30px;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\n\t\tbackground: #F6F1EF;\n\t\tborder-radius: 26px;\n\t\t&:hover {\n\t\t\tbackground: #f2dbd9;\n\t\t}\n\t\t&.disabled {\n\t\t\topacity: 0.5;\n\t\t}\n\t\t@include mobile {\n\t\t\theight: 40px;\n\n\t\t\tp {\n\t\t\t\tfont-size: 12px;\n\t\t\t}\n\t\t}\n\t\t&.disabled {\n\t\t\topacity: 0.5;\n\t\t}\n\t\tp {\n\t\t\tfont-size: 14px;\n\t\t}\n\t\t\n\t\t.right-checkout {\n\t\t\tcursor: pointer;\n\t\t\tmargin: 0 auto;\n\t\t\tpadding: 0px 15px 0px 10px;\n\t\t\tp {\n\t\t\t\tcolor: var(--color-black);\n\t\t\t\tfont-family: AppFontMedium;\n\t\t\t}\n\t\t\ttext-transform: uppercase;\n\t\t}\n\t}\n}\n","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
